module.exports = __webpack_public_path__ + "img/wangdian.57439f97.png";